import React, { useState } from 'react'
import CloseSVG from '../../assets/svg/close.svg'
import Modal from '../modal/modal'
import ButtonSelect from '../button-select'
import Button from '../button'
import SingleUpdateVoluntaryPension from './single-update-voluntary-pension'
import BulkUpdateVoluntaryPension from './bulk-update-voluntary-pension'

function SelectVoluntaryOption({ isOpen, closeModal }) {
  const [option, setOption] = useState('basic')
  const [basic, setBasic] = useState(false)
  const [advanced, setAdvanced] = useState(false)

  function submit() {
    if (option === 'basic') {
      setBasic(true)
    } else if (option === 'advanced') {
      setAdvanced(true)
    }
  }

  return (
    <>
      {basic && (
        <SingleUpdateVoluntaryPension
          isOpen={basic}
          closeModal={() => {
            setBasic(false)
            closeModal()
          }}
        />
      )}
      {advanced && (
        <BulkUpdateVoluntaryPension
          isOpen={advanced}
          source='default'
          closeModal={() => {
            setAdvanced(false)
            closeModal()
          }}
        />
      )}
      <Modal
        scrollable={true}
        className='!max-w-[600px] !rounded-none overflow-auto'
        isOpen={isOpen}
        centered={true}
      >
        <div className='flex flex-col overflow-auto'>
          <div className='px-3 pt-4'>
            <div className='flex justify-between items-center'>
              <span className='header-4'>Select option</span>
              <div className='cursor-pointer' onClick={() => closeModal()}>
                <img src={CloseSVG} alt='close' />
              </div>
            </div>
          </div>
          <hr className='divider' />
          <div className='flex flex-col items-center w-full gap-3'>
            <p className='text-[15px]'>
              Select your desired option to update employee voluntary pension
            </p>
            <div className='flex flex-col justify-center h-full min-h-[370px] max-w-[85%] w-full'>
              <ButtonSelect
                title={'Update Single Employee Voluntary Pensiom'}
                subtitle={'Update employee voluntary pension'}
                isActive={option === 'basic'}
                onClick={() => setOption('basic')}
              />

              <ButtonSelect
                title={'Import Employee Voluntary Pension'}
                subtitle={
                  'Import voluntary pension using a pre-defined XLSX template'
                }
                isActive={option === 'advanced'}
                onClick={() => setOption('advanced')}
                className='mt-8'
              />

              <div className='w-full mt-[20px]'>
                <Button text='NEXT' type='submit' onClick={() => submit()} />
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </>
  )
}

export default SelectVoluntaryOption
